



((docs)=>{
    const myDoc = docs;
    const header = myDoc.getElementById('siteHeader');
    const sticky = header.offsetTop;
    const onScroll = () => {
      if (window.scrollY > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky")
      }
    }
    window.addEventListener('scroll', onScroll);

    const addOvrlay = () => {
      let overlayEle = myDoc.createElement('div');
          overlayEle.className = 'overlay';
      let dropOverBg = myDoc.querySelector('.overlay');
          //! dropOverBg? myDoc.body.appendChild(overlayEle):'';
          if (!dropOverBg) {
            myDoc.body.appendChild(overlayEle);
            myDoc.body.classList.add('no-scroll'); // Prevent background scroll
            myDoc.documentElement.classList.add('no-scroll');
          }
    }

    const maxMediaFn = (dWidth) => {
      return  window.matchMedia(`(max-width: ${dWidth})`);
    }

    const menuDropdown = (nai) => {
      const menu = myDoc.querySelector(nai);
      const offcanv = myDoc.querySelector('.nav-min');
      let dropMenuItems = menu.querySelectorAll('.haveChild');
      if(maxMediaFn('991px').matches) {
          let mobMnuHdr = myDoc.querySelector('.nav-min-header');
          let mobMnuCloser = myDoc.querySelector('.nav-min-close');
          Object.keys(dropMenuItems).forEach((key) => {
              let item = dropMenuItems[key].querySelector('a');
              //console.log(item);
              let subMenu = dropMenuItems[key].querySelector('.dropdown-menu');
              let chieldCloseBtn = subMenu.querySelector('.nav-min-menu-children-closer');
              item.addEventListener('click', (e) => {
                  e.preventDefault();
                  subMenu.classList.add('show');
                  mobMnuHdr.classList.add('position-fixed');
              });
              chieldCloseBtn.addEventListener('click', (e) => {
                  e.preventDefault();
                  subMenu.classList.remove('show');
                  setTimeout(() => {
                      mobMnuHdr.classList.remove('position-fixed');
                  }, 10);
              });
              mobMnuCloser.addEventListener('click', (e) => {
                  subMenu.classList.remove('show');
                  setTimeout(() => {
                      mobMnuHdr.classList.remove('position-fixed');
                  }, 10);
              });
          });


          offcanv.addEventListener('hide.bs.offcanvas', event => {
            mobMnuHdr.classList.remove('position-fixed');
          });



      }else{
        let dropMenu = menu.querySelectorAll('.dropdown');


        myDoc.addEventListener('click', (e) => {
          let dropMenuTglr = e.target.closest('.dropdown-menu'),
              dropOverBg = myDoc.querySelector('.overlay');
            if(!dropMenuTglr && dropOverBg) {
              dropOverBg.remove();
              myDoc.body.classList.remove('no-scroll'); // Re-enable scroll
              myDoc.documentElement.classList.remove('no-scroll');
            }
        });

        dropMenu.forEach((item) => {
          item.addEventListener('show.bs.dropdown', event => {
              setTimeout(() => {
                addOvrlay();
              }, 6);
          });
        });
      }

    };

    menuDropdown('.nav-min-menu');
    window.addEventListener('resize', (e)=>{
        console.log('resize');
        menuDropdown('.nav-min-menu');
    });


    let filter = myDoc.querySelectorAll('.filter-btn');
    const filtertxt = myDoc.querySelector('.filter-txt');
    if(filter) {
      let eachClick = true;

      const filterF = (filterp, galV) => {
        if(eachClick) {
          eachClick=false;
          filterp.classList.add('show');
          galV?galV.classList.add('col-xl-10'):'';
          filtertxt.textContent = `Hide filters`;
        } else {
          eachClick=true;
          filterp.classList.remove('show');
          galV?galV.classList.remove('col-xl-10'):'';
          filtertxt.textContent = `Show filters`;
        }
      }
      Object.keys(filter).forEach((ele) => {
        filter[ele].addEventListener('click', (e) => {
          if(! maxMediaFn('1199px').matches){
            let filterPanl = myDoc.querySelector('.filter');
            let galView = myDoc.querySelector('.gallery-view');
            filterF(filterPanl, galView);
          }else {
            let filterPanl = myDoc.querySelector('.filter');
            filterF(filterPanl);

            myDoc.addEventListener('click', (e) => {
             // let dropMenuTglr = e.target.closest('.filter'),
                overBG = myDoc.querySelector('.overlay');
                if(!e.target.closest('.filter') && overBG) {
                  overBG.remove();
                  eachClick=true;
                  myDoc.querySelector('.filter').classList.remove('show');
                }else if(e.target.closest('.filter-close')) {
                  overBG?overBG.remove():'';
                }
            });

            if(!e.target.closest('.filter-close')) {
              setTimeout(() => {
                addOvrlay();
              }, 0);
            }
          }
        });
      });

    }

    let searchByKeyUp = myDoc.querySelectorAll('.searchByKeyUp');

    //scalable search function
    function filterFunction(element, input) {
      var  filter, ul, li, a, i;
      filter = input.value.toUpperCase();
      //div = document.getElementById("filter_dorpdown_list");
      a = element.getElementsByTagName("a");
      for (i = 0; i < a.length; i++) {
          txtValue = a[i].textContent || a[i].innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
              a[i].style.display = "";
          } else {
              a[i].style.display = "none";
          }
      }
    }

    if(searchByKeyUp){
      Object.keys(searchByKeyUp).forEach(ele => {
        let input = searchByKeyUp[ele].querySelector(".form-control");
        let itemWrap = searchByKeyUp[ele].querySelector(".model-search");
        //console.log(input, itemWrap) ;
        if(input){
          input.addEventListener('keyup', (e) => {
            filterFunction(itemWrap, e.target);
          });
        }
      })
    }

    const date = myDoc.querySelector('.date');
    const datervw = myDoc.querySelector('.flatpickr-input');
    const time = myDoc.querySelector('.time');
    if(date){
        setTimeout(()=>{
            flatpickr(date, {
                minDate: "today",
                altFormat: "F j, Y",
                maxDate: new Date().fp_incr(14) // 14 days from now
            });
        }, 1800)
    }
    if(datervw){
        setTimeout(()=>{
            flatpickr(datervw, {
                altInput: true,
                altFormat: "F j, Y",
                disableMobile: true,
                allowInput: true,
                dateFormat: "Y-m-d",
            });
        }, 1800)
    }
    if(time){
        setTimeout(()=>{
            flatpickr(time, {
                enableTime: true,
                noCalendar: true,
                disableMobile: true,
                dateFormat: "h:i",
                time_24hr: true
            });
        }, 1800)
    }

    const inputFilewrap = myDoc.querySelectorAll('.inputFile');
    if(inputFilewrap) {
      Object.keys(inputFilewrap).forEach(function(key) {
          inputFilewrap[key].querySelector('[type="file"]').addEventListener('change', function(event) {
              if (event.target.files.length > 0) {
                event.target.nextElementSibling.innerText = inputFilewrap[key].querySelector('[type="file"]').files[0].name;
              }
          });
      });
    }


    //accordion
    let accordianBody = myDoc.querySelectorAll('.accordion-collapse');
    if(accordianBody) {
        Object.keys(accordianBody).forEach(function(key) {
            accordianBody[key].addEventListener('shown.bs.collapse', function(e) {
                //accordianBody[key].parentElement.classList.add('active');
                // console.log(accordianBody[key]);
                e.stopPropagation();
                let accorItem = e.target.closest('.accordion-item');
                window.scrollTo({
                    top: accorItem.offsetTop - 100,
                    behavior: 'smooth'
                });
            });
        });
    }


    // search

    const searchOpen = () => {
      const search = myDoc.querySelector('.search-form');
      let formInput = search.querySelector('.form-control');

      // Create overlay div
      let divEle = myDoc.createElement('div');
      divEle.className = 'search-overlay';
      myDoc.body.appendChild(divEle);

      // Create close button
      let closeButton = myDoc.createElement('button');
      closeButton.className = 'btn-search-close';
      closeButton.textContent = 'Close'; // Set button text
      divEle.appendChild(closeButton); // Append close button to the overlay

      search.classList.add('active');
      formInput.focus();

      // Close button functionality
      closeButton.addEventListener('click', function() {
          myDoc.body.removeChild(divEle); // Remove overlay
          search.classList.remove('active'); // Deactivate search form
      });
  };

  const searchBtn = myDoc.querySelectorAll('.search-btn');
  Object.keys(searchBtn).forEach(function(key) {
      searchBtn[key].addEventListener('click', function(e) {
          e.preventDefault();
          searchOpen();
          return false;
      });
  });

  myDoc.addEventListener('click', function(event) {
      let searchManHdr = myDoc.querySelector('.search');
      let searchBtn = myDoc.querySelector('.search-btn');
      const search = myDoc.querySelector('.search-form');

      if (searchManHdr && !searchManHdr.contains(event.target) && (searchBtn && !searchBtn.contains(event.target))) {
          let divEle = myDoc.querySelector('.search-overlay');
          if (divEle) {
              myDoc.body.removeChild(divEle); // Remove overlay
          }
          search.classList.remove('active'); // Deactivate search form
      }
  });


    //favourite

    myDoc.addEventListener('click', function(event) {
    //   console.log(event.target);
      if (event.target.classList.contains('favourites-icon')) {
          event.target.classList.toggle('active');
          if (event.target.classList.contains('active')) {
              event.target.parentElement.querySelector('.favourites-message').textContent = 'Added to favourites!';
          } else {
              event.target.parentElement.querySelector('.favourites-message').textContent = 'Removed from Favourites!';
          }
          event.target.parentElement.querySelector('.favourites-message').classList.add('active');
      }
  });

  myDoc.addEventListener('click', function(event) {
      if (event.target.classList.contains('favourites-message')) {
          event.target.classList.remove('active');
      }
  });

  myDoc.addEventListener('click', function(event) {
      if (!event.target.closest('.favourites')) {
          myDoc.querySelectorAll('.favourites-message').forEach(function(message) {
              message.classList.remove('active');
          });
      }
  });

})(document);
